function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.785 9.734l-9.082 12.152-6.488-5.117"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1 16a15 15 0 1030 0 15 15 0 00-30 0h0z"
}));

function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
}

export default SvgCheck;